import { http } from './config'

export default {
    getLinhasComCategorias: () => {
        return http.get('linha/linhas-com-categorias')
    }
}